import { AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { FeedNotificationItem } from '../../model/content/contentFeedNotification.model';
import { AdvisoriesItem } from '../../model/content/contentadvisories.model';
import { NewsItem } from '../../model/content/contentnews.model';
import { ContentNotification } from '../../model/content/contentnotification.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { UpcomingTripService } from '../../services/upcoming-trip-service/upcoming-trip.service';

@Component({
  selector: 'ngc-flyout-feed',
  templateUrl: 'flyout-feed.component.html'
})
export class FlyoutFeedComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
  @ViewChild('autoShownModal') autoShownModal: ModalDirective;
  @ViewChild('dialog') dialog: any;
  // tslint:disable-next-line:no-input-rename
  @Input('isloggedInFeed') isloggedInFeedTab: boolean;
  @Input() isLoggedInData: boolean;
  @Input() showNewFlyout: any;
  @Input() triggerNewsData: boolean;
  flyOutPositionHeight: any;
  flyoutFeedHeaderPosition: any;
  isModalShown = false;
  isAlwaysShow = true;
  isShoppingHeader: boolean;
  isloggedInFeedNotify = false;
  modalConfig = {
    animated: false,
    show: true
  };

  public advisories: AdvisoriesItem[] = [];
  public news: NewsItem[] = [];
  public contentNotification: ContentNotification;
  public player: AnimationPlayer;
  public feedNotification: FeedNotificationItem[] = [];
  public resAcctSumDetails: any;
  contentHeaderFooterServiceSubscribe: Subscription;
  accountSummaryServiceSubscribe: Subscription;
  tripDetails: any;
  showEmptyMessage = false;
  showEmptyMessageNews = false;
  isadvisories = false;
  isnews = false;
  isnotification = true;
  viewAllLabel = '';
  spinner = false;
  isFlyoutLoaded = false;
  notificationModalLoaded = false;
  isDelta = true;
  flyoutObject: any;
  private unsubscribe: Subject<void> = new Subject();
  private animationTime = '300ms';

  constructor(
    public bsModalRef: BsModalRef,
    private cdref: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private srv: CommonService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _builder: AnimationBuilder,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private accountSummaryService: AccountSummaryService,
    private srvUpcomingTrips: UpcomingTripService,
    private datalayer: DataLayer,
    private sanitizer: DomSanitizer,
    private userSession: UserSessionService,
    private loggingService: LoggingService
  ) {}

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.flyoutObject = this.srv.flyoutPosition('feed', this.isFlyoutLoaded);
    this.flyOutPositionHeight = this.flyoutObject?.flyOutPositionHeight ?? 0;
    this.flyoutFeedHeaderPosition =
      this.flyoutObject?.flyoutFeedHeaderPosition ??
      this.flyoutFeedHeaderPosition;
    if (isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth < 992 && document.body.scrollWidth > 767) {
        const modelContainer = document.getElementsByTagName('modal-container');
        if (modelContainer && modelContainer.length > 0) {
          modelContainer[0].classList.add('notification-header-modal');
          this.notificationModalLoaded = true;
        }
      }
    }
  }

  @HostListener('touchmove', ['$event']) onTouchMoveEvent(event) {
    if (isPlatformBrowser(this.platformId)) {
      if (document.body.classList.contains('modal-open')) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  }

  ngOnInit() {
    this.flyoutObject = this.srv.flyoutPosition('feed', this.isFlyoutLoaded);
    this.flyOutPositionHeight = this.flyoutObject?.flyOutPositionHeight ?? 0;
    this.flyoutFeedHeaderPosition =
      this.flyoutObject?.flyoutFeedHeaderPosition ??
      this.flyoutFeedHeaderPosition;
    this.contentHeaderFooterServiceSubscribe =
      this.contentService.contentHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            this.spinner = true;
            if (
              data &&
              data.header.auxiliaryNavigation.get('notification') !== undefined
            ) {
              this.contentNotification =
                data.header.auxiliaryNavigation.get('notification').details;
              if (data?.advisories?.advisoriesList) {
                if (data.advisories.advisoriesList.length > 3) {
                  for (let i = 0; i < 3; i++) {
                    this.advisories.push(data.advisories.advisoriesList[i]);
                  }
                } else {
                  this.advisories = data.advisories.advisoriesList;
                }
              }
              if (this.advisories?.length === 0 || !this.advisories) {
                this.showEmptyMessage = true;
              } else {
                this.showEmptyMessage = false;
              }
              this.cdref.detectChanges();
            }
            this.spinner = false;
          },
          (err) => {
            this.showEmptyMessage = true;
            this.loggingService.log('Caught Error: ' + err);
            this.spinner = false;
          }
        );
    if (this.isloggedInFeedTab === true) {
      if (this.userSession.getServiceWorkerCheck()) {
        this.getNotification();
      }
      this.getNewsData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const isTriggerNewsAvailable = changes.hasOwnProperty('triggerNewsData');
    if (
      isTriggerNewsAvailable &&
      changes.triggerNewsData.currentValue &&
      this.triggerNewsData
    ) {
      this.getNewsData();
    }
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
    if (this.isloggedInFeedNotify === true) {
      this.renderer.insertBefore(
        document.getElementsByClassName('nav-tabs')[1],
        document.getElementsByClassName('notify-tab-link')[0],
        this.elementRef.nativeElement.querySelector('.advisory-tab-link')
      );
    }
    const modalElement = document.getElementsByTagName('modal-container');
    if (modalElement !== undefined && modalElement.length > 0) {
      modalElement[0].addEventListener(
        'click',
        this.backDropClickHandler.bind(this)
      );
      modalElement[0].setAttribute('aria-labelledby', 'feed');
    }
    const activeModalElement = this.elementRef.nativeElement;
    this.notificationFocusInsidePopup(activeModalElement);
    this.dynamicAttributesaddedintoFeedpopup();
  }

  addTexttoFeedContainer() {
    const feedContElRef = this.elementRef.nativeElement.querySelectorAll(
      '.flyout-loggedin-feed ul'
    );
    const feedCont = Array.prototype.slice.call(feedContElRef);
    if (feedCont) {
      feedCont.forEach((feed) => {
        const feedContainer = feed.querySelectorAll('ul li a')[0];
        if (feedContainer) {
          this.createSpantoFeedpopup(feed, feedContainer);
        }
      });
    }
  }

  createSpantoFeedpopup(feedCont, feedlast) {
    const createSpan = document.createElement('span');
    this.renderer.setAttribute(createSpan, 'class', 'sr-only');
    createSpan.innerText =
      feedCont.parentElement.parentElement.classList.value + ' container';
    this.renderer.insertBefore(
      feedlast,
      createSpan,
      feedlast.firstElementChild
    );
  }

  dynamicAttributesaddedintoFeedpopup() {
    const tabRolechange = this.elementRef.nativeElement.querySelectorAll(
      '.feed-flyout .tab-container ul'
    );
    if (tabRolechange && tabRolechange.length > 0) {
      tabRolechange[0]
        .querySelectorAll('li')[0]
        .addEventListener('keydown', this.handlekeydown.bind(this));
      tabRolechange[0]
        .querySelectorAll('li')[1]
        .addEventListener('keydown', this.handlekeydown.bind(this));
      for (let i = 0; i < tabRolechange[0].querySelectorAll('li').length; i++) {
        if (
          tabRolechange[0].querySelectorAll('li')[i].children[0].id ===
          'advisory-tab-link'
        ) {
          this.renderer.setAttribute(
            tabRolechange[0].querySelectorAll('li')[i].children[0],
            'aria-selected',
            'true'
          );
        } else {
          this.renderer.setAttribute(
            tabRolechange[0].querySelectorAll('li')[i].children[0],
            'aria-selected',
            'false'
          );
        }
        this.renderer.setAttribute(
          tabRolechange[0].querySelectorAll('li')[i].children[0],
          'role',
          'tab'
        );
        this.renderer.removeAttribute(
          tabRolechange[0].querySelectorAll('li')[i],
          'role'
        );
      }
    }
    if (this.elementRef.nativeElement.querySelector('.feed-flyout')) {
      this.renderer.setAttribute(
        this.elementRef.nativeElement.querySelector(
          '.feed-flyout .tab-container .advisory-tab-link a'
        ),
        'aria-controls',
        'advisory-tab'
      );
      this.renderer.setAttribute(
        this.elementRef.nativeElement.querySelector(
          '.feed-flyout .tab-container .news-tab-link a'
        ),
        'aria-controls',
        'news-tab'
      );
    }
  }

  handlekeydown(e) {
    if ([37, 38, 39, 40].includes(e.keyCode)) {
      if (e.target?.parentElement?.nextElementSibling) {
        e.target.parentElement.nextElementSibling.children[0].setAttribute(
          'tabindex',
          '0'
        );
        e.target.parentElement.nextElementSibling.click();
        e.target.parentElement.nextElementSibling.children[0].click();
        e.target.parentElement.nextElementSibling.children[0].focus();
      } else if (e.target?.parentElement?.previousElementSibling) {
        e.target.parentElement.previousElementSibling.children[0].setAttribute(
          'tabindex',
          '0'
        );
        e.target.parentElement.previousElementSibling.click();
        e.target.parentElement.previousElementSibling.children[0].click();
        e.target.parentElement.previousElementSibling.children[0].focus();
      }
    }
    if (e.keyCode === 9 && !(e.shiftKey && e.keyCode === 9)) {
      if (e.target.attributes['aria-controls'].value === 'advisory-tab') {
        if (e.target?.parentElement?.nextElementSibling) {
          e.target.parentElement.nextElementSibling.children[0].setAttribute(
            'tabindex',
            '-1'
          );
        }
        if (e.target?.parentElement?.previousElementSibling) {
          e.target.parentElement.previousElementSibling.children[0].setAttribute(
            'tabindex',
            '-1'
          );
        }
      }
    }
  }

  notificationFocusInsidePopup(activeModalElement) {
    const tabbableElsfirst = activeModalElement.querySelector(
      'li.nav-item a.active'
    );
    activeModalElement.addEventListener('keydown', (e: any) => {
      const lastElemFocus = this.isadvisories
        ? activeModalElement.querySelector(
            '.modal-footer a.advisories-view-all-link'
          )
        : activeModalElement.querySelector(
            '.modal-footer a.news-view-all-link'
          );
      if (e.keyCode === 9 && !(e.shiftKey && e.keyCode === 9)) {
        if (document.activeElement === lastElemFocus) {
          tabbableElsfirst.focus();
          e.preventDefault();
        }
      }
      if (e.keyCode === 9 && e.shiftKey && e.keyCode === 9) {
        if (document.activeElement === tabbableElsfirst) {
          lastElemFocus.focus();
          e.preventDefault();
        }
      }
    });
  }

  getConfirmationNumber(smNumber) {
    if (smNumber) {
      if (this.srvUpcomingTrips) {
        if (this.srvUpcomingTrips.upComingTrips) {
          this.tripDetails = this.srvUpcomingTrips.upComingTrips;
        } else {
          this.srvUpcomingTrips.upcomingTripDataChanged
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(
              (upcomingTrip) => {
                this.spinner = true;
                this.tripDetails = upcomingTrip.data;
                this.spinner = false;
              },
              (err) => {
                this.loggingService.log('Caught Error: ' + err);
              }
            );
          this.tripDetails = this.srvUpcomingTrips.getTripDetails(smNumber);
        }
      }
    }
  }

  loadNotification(tripDetails) {
    if (tripDetails?.flightTripDetails) {
      this.accountSummaryService
        .getTripNotification(tripDetails.flightTripDetails.pnrNbr)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (resData) => {
            if (resData) {
              if (resData !== undefined && resData !== '' && resData !== null) {
                this.spinner = true;
                if (resData.messageCount > 0) {
                  this.isloggedInFeedNotify = true;
                  if (resData.messageCount > 3) {
                    for (let i = 0; i < 3; i++) {
                      this.feedNotification[i] = resData.messageData[i];
                      this.feedNotification[i].flightDate = this.FormateDate(
                        this.feedNotification[i].flightDate
                      );
                    }
                  } else {
                    for (let i = 0; i < resData.messageCount; i++) {
                      this.feedNotification[i] = resData.messageData[i];
                      this.feedNotification[i].flightDate = this.FormateDate(
                        this.feedNotification[i].flightDate
                      );
                    }
                  }
                }
              }
              this.cdref.detectChanges();
              this.spinner = false;
            }
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    }
  }

  getNotification() {
    this.accountSummaryServiceSubscribe = this.accountSummaryService
      .getAccountSummaryDetails()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res) => {
          this.resAcctSumDetails = res;
          if (this.resAcctSumDetails) {
            this.tripDetails = this.getConfirmationNumber(
              this.resAcctSumDetails.smNumber
            );
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.feedFocuslastEle();
  }

  getNewsData() {
    if (this.isDelta && isPlatformBrowser(this.platformId)) {
      if (this.news && this.news.length === 0) {
        try {
          this.srv
            .getRssNews()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  if (data !== undefined && data !== '' && data !== null) {
                    if (data.length > 3) {
                      for (let i = 0; i < 3; i++) {
                        this.news.push(data[i]);
                      }
                    } else {
                      this.news = data;
                    }
                  }
                  if (this.news && this.news.length === 0) {
                    this.showEmptyMessageNews = true;
                    this.loggingService.log(
                      'There are no news returned from news.delta.com'
                    );
                  } else {
                    this.showEmptyMessageNews = false;
                  }
                  this.cdref.detectChanges();
                } else {
                  this.showEmptyMessageNews = true;
                  this.loggingService.log(
                    'There are no news returned from news.delta.com'
                  );
                }
                this.addTexttoFeedContainer();
              },
              (err) => {
                this.showEmptyMessageNews = true;
                this.loggingService.log(
                  'Error occured in subscribe call of : getRssNews :: ' + err
                );
              }
            );
        } catch (e) {
          this.news = [];
        }
      } else {
        this.showEmptyMessageNews = false;
      }
    }
  }

  backDropClickHandler(event) {
    const flyout = event.target.parentElement;
    if (
      flyout &&
      isPlatformBrowser(this.platformId) &&
      this.notificationModalLoaded
    ) {
      const isModalContainerClicked =
        event.target.classList.contains('notification-header-modal') ||
        event.target.classList.contains('feed-flyout') ||
        event.target.classList.contains('flyout-loggedin-feed') ||
        flyout.classList.contains('modal-content');
      if (isModalContainerClicked) {
        this.bsModalRef.hide();
        this.notificationModalLoaded = false;
      }
    }
  }

  close() {
    if (this.bsModalRef && isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth < 992) {
        const feedheader = document.getElementsByClassName('feed-header')[0];
        if (feedheader) {
          feedheader.classList.remove('feed-header-fixed');
          feedheader.setAttribute(
            'style',
            'top :' + this.flyoutFeedHeaderPosition + 'px'
          );
        }
        const mobileViewAll =
          document.getElementsByClassName('mobile-view-all');
        if (mobileViewAll !== undefined && mobileViewAll !== null) {
          mobileViewAll[0].classList.add('mobile-view-all-absolute');
        }
        this.bsModalRef.hide();
        document.getElementsByTagName('html')[0].classList.remove('no-scroll');
      } else {
        this.bsModalRef.hide();
        document.getElementsByTagName('html')[0].classList.remove('no-scroll');
      }
    }
  }

  tabSelected(tabValue: string, event) {
    if (tabValue === 'advisories') {
      this.isadvisories = true;
      this.isnews = false;
      this.isnotification = false;
      this.feedFocuslastEle();
    } else if (tabValue === 'news') {
      this.isadvisories = false;
      this.isnews = true;
      this.isnotification = false;
      this.getNewsData();
    } else {
      this.isadvisories = false;
      this.isnews = false;
      this.isnotification = true;
    }
    const tabRolechange = this.elementRef.nativeElement.querySelectorAll(
      '.feed-flyout .tab-container ul'
    );
    if (tabRolechange[0]?.querySelectorAll('li')?.length > 0) {
      for (let i = 0; i < tabRolechange[0].querySelectorAll('li').length; i++) {
        const z = tabRolechange[0].querySelectorAll('li')[i].children[0];
        this.renderer.setAttribute(z, 'aria-selected', 'false');
      }
    }
    if (
      this.elementRef.nativeElement.querySelector('#' + event.id + '-link') !==
        null &&
      this.elementRef.nativeElement.querySelector('#' + event.id + '-link') !==
        undefined
    ) {
      this.renderer.setAttribute(
        this.elementRef.nativeElement.querySelector('#' + event.id + '-link'),
        'aria-selected',
        'true'
      );
    }
  }

  FormateDate(dateString: any) {
    dateString = dateString.split('T');
    dateString = dateString[0].split('-');
    dateString = dateString[0] + '-' + dateString[2] + '-' + dateString[1];
    return dateString;
  }

  feedFocuslastEle() {
    this.isnotification = false;
    const lastEle = this.elementRef.nativeElement.querySelector(
      '.tab-pane.active .advisoryLastEle a'
    );
    if (lastEle) {
      lastEle.addEventListener(
        'keydown',
        this.focusOutFunctionAxFeed.bind(this)
      );
    }
  }

  focusOutFunctionAxFeed() {
    const lastfocusElement =
      this.elementRef.nativeElement.parentElement.parentElement.parentElement.querySelector(
        '.nav-tabs .mydelta-tab-link .nav-link'
      );
    lastfocusElement.focus();
    event.preventDefault();
  }

  ngOnDestroy() {
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      // Loadtest ObsUnsub
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
